<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="packingListsFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            fixed-header
            item-key="id"
            :items-per-page.sync="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [25, 50, 100] }"
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="6" class="d-flex mb-n3">
                        <h1 class="mr-4">PACKING LISTS</h1>
                    </v-col>
                    <v-col cols="6" class="d-flex mb-n3">
                        <v-spacer />
                        <v-btn
                            v-if="
                                createPackingListPermission || isPMCollaborator
                            "
                            rounded
                            color="primary"
                            @click="createPackingList = true"
                            class="mx-2"
                            :disabled="loading"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                            {{ $vuetify.breakpoint.smAndDown ? '' : 'NEW' }}
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.code`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="search"
                    dense
                />
            </template>
            <template v-slot:[`header.workOrdersAndBoms`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="workOrderAndBomToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.createdBy`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="userToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.createdOn`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="createdOnToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.shippedBy`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="shippedByToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.requestedShipmentDate`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="requestedShipmentDateToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.status`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="statusToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.notes`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="notesToFilter"
                    dense
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.createdBy`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.createdByName }}</p>
                </div>
            </template>
            <template v-slot:[`item.workOrdersAndBoms`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.selectedWorkOrdersAndBomsString }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.project`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.projectLabel }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.createdOn`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.createdOnLabel }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.shippedBy`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.shippedByName || 'N/A' }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.requestedShipmentDate`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.requestedShipmentDate }}
                    </p>
                </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                <div class="d-flex justify-center">
                    <v-chip
                        :color="statusColor[item.status]"
                        class="white--text text-capitalize"
                    >
                        {{
                            item.status == 'referred'
                                ? 'inDelivery'
                                : item.status
                        }}
                    </v-chip>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openProcessPackingList(item)">
                        <v-icon>{{
                            item.status !== 'completed'
                                ? 'mdi-pencil'
                                : 'mdi-eye'
                        }}</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="deletableStatuses.includes(item.status)"
                        small
                        icon
                        @click="openDeletePackingList(item)"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!--PACKING ORDER FORM-->
        <v-dialog
            v-model="packingListForm"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <PackingForm
                v-if="packingListForm"
                :project="selectedProject"
                :originalOrder="selectedOrder"
                :onlySuggested="!createPackingListPermission"
                @close="closePackingListForm"
                @addPackingList="addPackingList"
                @replacePackingList="replacePackingList"
            />
        </v-dialog>
        <!--PROCESS PACKING ORDER-->
        <v-dialog
            v-model="processPackingList"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <ProcessPackingPending
                v-if="processPackingList && selectedOrder.status == 'pending'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                :onlySuggested="!createPackingListPermission"
                @replacePackingList="replacePackingList"
                @close="closeProcessPackingList"
                @addPackingList="addPackingList"
            />
            <ProcessPackingScheduled
                v-if="processPackingList && selectedOrder.status == 'scheduled'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                :onlySuggested="!createPackingListPermission"
                @replacePackingList="replacePackingList"
                @close="closeProcessPackingList"
            />
            <ProcessPackingReferred
                v-if="processPackingList && selectedOrder.status == 'referred'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                :onlySuggested="!createPackingListPermission"
                @replacePackingList="replacePackingList"
                @close="closeProcessPackingList"
            />
            <ProcessPackingShipped
                v-if="processPackingList && selectedOrder.status == 'shipped'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                :onlySuggested="!createPackingListPermission"
                @replacePackingList="replacePackingList"
                @close="closeProcessPackingList"
            />
            <ProcessPackingCompleted
                v-if="processPackingList && selectedOrder.status == 'completed'"
                :originalOrder="selectedOrder"
                :project="selectedProject"
                :onlySuggested="!createPackingListPermission"
                @replacePackingList="replacePackingList"
                @close="closeProcessPackingList"
            />
        </v-dialog>
        <!--CREATE PACKING LIST-->
        <v-dialog
            v-model="createPackingList"
            :retain-focus="false"
            persistent
            width="600px"
        >
            <CreatePackingList
                v-if="createPackingList"
                :projects="projects"
                :onlySuggested="
                    !createPackingListPermission && !isPMCollaborator
                "
                :currentUser="user"
                @close="createPackingList = false"
                @selectProject="selectProject"
            />
        </v-dialog>
        <!--Delete Packing Order-->
        <v-dialog
            v-model="deleteWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="deleteWarning">
                <v-card-title class="text-h5"
                    >Delete Packing Order</v-card-title
                >
                <v-card-text>
                    Are you sure you want to delete this packing order?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="closeDeletePackingList"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deletePackingList"
                        text
                        color="error"
                        :loading="loading"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import API from '@/services/api'
import { mapMutations } from 'vuex'
import { buildWorkOrdersAndBomsString } from '@/utils/packingListCodes'

const DELETABLE_STATUSES = [
    'inProgress',
    'rejected',
    'domesticShipping',
    'reservedForProject',
    'reserved',
]
const FILTER_DEBOUNCE_MS = 200

export default {
    name: 'MainPacking',
    components: {
        PackingForm: () => import('@/components/Packing/PackingForm.vue'),
        ProcessPackingPending: () =>
            import('@/components/Packing/ProcessPackingPending.vue'),
        ProcessPackingScheduled: () =>
            import('@/components/Packing/ProcessPackingScheduled.vue'),
        ProcessPackingReferred: () =>
            import('@/components/Packing/ProcessPackingReferred.vue'),
        ProcessPackingShipped: () =>
            import('@/components/Packing/ProcessPackingShipped.vue'),
        ProcessPackingCompleted: () =>
            import('@/components/Packing/ProcessPackingCompleted.vue'),
        CreatePackingList: () =>
            import('@/components/Packing/CreatePackingList.vue'),
    },
    props: {
        project: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        projects: [],
        selectedProject: {},
        deleteWarning: false,
        selectedOrder: undefined,
        processPackingList: false,
        packingListForm: false,
        statusToFilter: undefined,
        shippedByToFilter: undefined,
        projectToFilter: undefined,
        requestedShipmentDateToFilter: undefined,
        createdOnToFilter: undefined,
        workOrderAndBomToFilter: undefined,
        userToFilter: undefined,
        notesToFilter: undefined,
        loading: false,
        activateAlert: false,
        alertMessage: undefined,
        search: null,
        headers: [
            {
                text: 'ORDER',
                value: 'code',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'center',
                sortable: false,
            },
            {
                text: 'WOS - BOMS',
                value: 'workOrdersAndBoms',
                align: 'center',
                sortable: false,
            },
            {
                text: 'CREATED BY',
                value: 'createdBy',
                align: 'center',
                sortable: false,
            },
            {
                text: 'CREATED ON',
                value: 'createdOn',
                align: 'center',
                sortable: false,
            },
            {
                text: 'SHIPPED BY',
                value: 'shippedBy',
                align: 'center',
                sortable: false,
                width: 110,
            },
            {
                text: 'REQUESTED SHIPMENT DATE',
                value: 'requestedShipmentDate',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'center',
                sortable: false,
            },
            {
                text: 'NET MASS',
                value: 'netMass',
                align: 'right',
                sortable: false,
            },
            {
                text: 'GROSS MASS',
                value: 'grossMass',
                align: 'right',
                sortable: false,
            },
            {
                text: 'STATUS',
                value: 'status',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        statusColor: {
            inProgress: '#9E9FA0',
            pending: '#FF9800',
            referred: 'primary',
            scheduled: '#25539d',
            rejected: 'red',
            completed: 'black',
            shipped: '#27BC4F',
            reserved: '#92cbee',
            reservedForProject: '#184b81',
            domesticShipping: '#1d283a',
        },
        packingLists: [],
        users: [],
        usersById: {},
        projectsById: {},
        deletableStatuses: DELETABLE_STATUSES,
        itemsPerPage: 50,
        appliedFilters: {
            search: '',
            workOrderAndBom: '',
            user: '',
            createdOn: '',
            shippedBy: '',
            requestedShipmentDate: '',
            project: '',
            status: '',
            notes: '',
        },
        createPackingList: false,
        user: {},
        createPackingListPermission: false,
        isPMCollaborator: false,
        countryName: 'colombia',
    }),
    computed: {
        packingListsFiltered() {
            const filters = this.appliedFilters
            const conditions = [this.filterReserved]
            if (filters.search) {
                conditions.push(this.filterOrder)
            }
            if (filters.workOrderAndBom) {
                conditions.push(this.filterWorkOrder)
            }
            if (filters.project) {
                conditions.push(this.filterProject)
            }
            if (filters.status) {
                conditions.push(this.filterStatus)
            }
            if (filters.user) {
                conditions.push(this.filterByUser)
            }
            if (filters.shippedBy) {
                conditions.push(this.filterByShippedBy)
            }
            if (filters.notes) {
                conditions.push(this.filterByNotes)
            }
            if (filters.requestedShipmentDate) {
                conditions.push(this.filterByRequestedShipmentDate)
            }
            if (filters.createdOn) {
                conditions.push(this.filterByCreatedOn)
            }
            conditions.push(this.filterByStatus)
            return this.packingLists.filter(order =>
                conditions.every(condition => condition(order))
            )
        },
    },
    watch: {
        search: 'queueFilters',
        workOrderAndBomToFilter: 'queueFilters',
        userToFilter: 'queueFilters',
        createdOnToFilter: 'queueFilters',
        shippedByToFilter: 'queueFilters',
        requestedShipmentDateToFilter: 'queueFilters',
        projectToFilter: 'queueFilters',
        statusToFilter: 'queueFilters',
        notesToFilter: 'queueFilters',
    },
    async mounted() {
        try {
            this.loading = true
            const [
                userResponse,
                usersResponse,
                projects,
                packingLists,
            ] = await Promise.all([
                API.getMyInfo(),
                API.getLiteUsers(),
                API.getAllLiteProjectsByUser(),
                API.getPackingLists({}),
            ])
            this.user = userResponse.data.user
            this.createPackingListPermission = this.user.permissions.includes(
                'createPackingList'
            )
            this.users = usersResponse.data.users
            this.usersById = this.indexById(this.users)
            this.projects = projects
            this.projectsById = this.indexById(this.projects)
            this.packingLists = packingLists
            this.packingLists.forEach(pl => {
                this.formatPackingList(pl, this.findProject(pl.projectId))
            })

            const userProjects = this.projects.filter(
                project =>
                    project.collaborators &&
                    project.collaborators.includes(this.user.id)
            )
            this.isPMCollaborator = userProjects.length > 0
            this.sort()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        clearTimeout(this._filterTimer)
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        buildWorkOrdersAndBomsString,

        /**
         * Determines the status of a packing list based on its conditions
         * @param {Object} pl - The packing list object
         * @param {Object} plProject - The project associated with the packing list
         * @returns {string} - The determined status or original status if no conditions match
         */
        getPLStatus(pl, plProject) {
            // Check if packing list meets the basic conditions for status change
            const hasNoPackages = !pl.packages || pl.packages.length === 0
            const hasScheduledDate = pl.scheduledFor || pl.requestedShipmentDate
            const isInProgress = pl.status === 'inProgress'

            if (!hasNoPackages || !hasScheduledDate || !isInProgress) {
                return pl.status // Return original status if conditions don't match
            }

            const isDomesticShipping =
                plProject.country &&
                plProject.country.toLowerCase() === this.countryName

            // Case 1: Has selected work orders
            if (pl.selectedWorkOrders) {
                return isDomesticShipping ? 'domesticShipping' : 'reserved'
            }

            // Case 2: No selected work orders
            if (!pl.selectedWorkOrders) {
                return isDomesticShipping
                    ? 'domesticShipping'
                    : 'reservedForProject'
            }

            // Return original status if no conditions match
            return pl.status
        },

        /**
         * Formats a packing list by setting its work orders/BOMs string, status, and mass calculations
         * @param {Object} packingList - The packing list to format
         * @param {Object} project - The project associated with the packing list
         */
        formatPackingList(packingList, project) {
            packingList.selectedWorkOrdersAndBomsString = this.buildWorkOrdersAndBomsString(
                packingList
            )
            packingList.status = this.getPLStatus(packingList, project)
            const netMass = this.calculateNetMass(packingList)
            packingList.netMass = netMass.toFixed(1)
            packingList.grossMass = this.calculateGrossMass(
                packingList,
                netMass
            ).toFixed(1)
            packingList.createdByName = this.findUserName(packingList.createdBy)
            packingList.shippedByName = this.findUserName(packingList.shippedBy)
            const projectRecord = project || {
                reference: '',
                name: '',
            }
            packingList.projectLabel = `${projectRecord.reference} - ${projectRecord.name}`
            packingList.createdOnLabel = this.formatCreatedOnLabel(
                packingList.createdOn
            )
        },
        calculateNetMass(pl) {
            return (
                pl.packages?.reduce((acc, pkg) => {
                    return (
                        acc +
                        (pkg.items?.reduce((itemAcc, item) => {
                            return itemAcc + Number(item.packingMass || 0)
                        }, 0) || 0)
                    )
                }, 0) || 0
            )
        },

        calculateGrossMass(pl, netMass) {
            const net = netMass != null ? netMass : this.calculateNetMass(pl)
            const crates =
                pl.packages?.reduce((acc, pkg) => {
                    return acc + Number(pkg.packageDimensions?.mass || 0)
                }, 0) || 0
            return net + crates
        },
        formatCreatedOnLabel(createdOn) {
            const seconds =
                createdOn && (createdOn.seconds || createdOn._seconds)
            if (!seconds) {
                return ''
            }
            const date = new Date(seconds * 1000)
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${date.getFullYear()}-${month}-${day}`
        },
        indexById(records) {
            const byId = {}
            ;(records || []).forEach(record => {
                if (record && record.id) {
                    byId[record.id] = record
                }
            })
            return byId
        },
        queueFilters() {
            clearTimeout(this._filterTimer)
            this._filterTimer = setTimeout(() => {
                this.appliedFilters = {
                    search: this.normalizeFilter(this.search),
                    workOrderAndBom: this.normalizeFilter(
                        this.workOrderAndBomToFilter
                    ),
                    user: this.normalizeFilter(this.userToFilter),
                    createdOn: this.normalizeFilter(this.createdOnToFilter),
                    shippedBy: this.normalizeFilter(this.shippedByToFilter),
                    requestedShipmentDate: this.normalizeFilter(
                        this.requestedShipmentDateToFilter
                    ),
                    project: this.normalizeFilter(this.projectToFilter),
                    status: this.normalizeFilter(this.statusToFilter),
                    notes: this.normalizeFilter(this.notesToFilter),
                }
            }, FILTER_DEBOUNCE_MS)
        },
        normalizeFilter(value) {
            return value ? String(value).toLowerCase() : ''
        },
        selectProject(project) {
            this.selectedProject = project
            this.createPackingList = false
            this.packingListForm = true
        },
        openCreatePackingList() {
            this.selectedProject = this.project
            this.packingListForm = true
        },
        closeDeletePackingList() {
            this.selectedOrder = null
            this.deleteWarning = false
        },
        openDeletePackingList(item) {
            this.selectedOrder = cloneDeep(item)
            this.deleteWarning = true
        },
        addPackingList(newPackingList, persistentForm = false) {
            this.activateAlert = true
            const plProject = this.findProject(newPackingList.projectId)

            // Format the new packing list
            this.formatPackingList(newPackingList, plProject)

            if (
                !newPackingList.selectedWorkOrders &&
                !newPackingList.selectedBOMs
            ) {
                if (
                    plProject.country &&
                    plProject.country.toLowerCase() == this.countryName
                ) {
                    this.alertMessage = `New Packing List ${newPackingList.code} Successfully Created As Domestic Shipping`
                    this.packingLists.push(newPackingList)
                } else {
                    this.alertMessage = `New Packing List ${newPackingList.code} Successfully Created As Reserved For Project. For more information see the packing list section in the project details`
                }
            } else if (
                !newPackingList.packages ||
                newPackingList.packages.length == 0
            ) {
                if (
                    plProject.country &&
                    plProject.country.toLowerCase() == this.countryName
                ) {
                    this.alertMessage = `New Packing List ${newPackingList.code} Successfully Created As Domestic Shipping`
                    this.packingLists.push(newPackingList)
                } else {
                    this.alertMessage = `New Packing List ${newPackingList.code} Successfully Created As Reserved. For more information see the packing list section in the project details`
                }
            } else {
                this.alertMessage = `New Packing List Successfully Created`
                this.packingLists.push(newPackingList)
            }

            // close packing list form if it is not persistent
            if (!persistentForm) {
                this.packingListForm = false
            } else {
                // update original order
                this.selectedOrder = cloneDeep(newPackingList)
            }
            this.sort()
        },
        replacePackingList(packingList) {
            const index = this.packingLists.findIndex(
                p => p.id == packingList.id
            )
            if (index >= 0) {
                this.packingLists.splice(index, 1, {
                    ...this.packingLists[index],
                    ...packingList,
                })
                const updated = this.packingLists[index]
                this.formatPackingList(
                    updated,
                    this.findProject(updated.projectId)
                )
            }
        },
        openProcessPackingList(item) {
            this.selectedOrder = cloneDeep(item)
            this.selectedProject = cloneDeep(this.findProject(item.projectId))
            if (
                [
                    'inProgress',
                    'rejected',
                    'reserved',
                    'reservedForProject',
                    'domesticShipping',
                ].includes(item.status)
            ) {
                this.packingListForm = true
            } else {
                this.processPackingList = true
            }
        },
        closeProcessPackingList() {
            this.selectedOrder = null
            this.selectedProject = null
            this.processPackingList = false
        },
        closePackingListForm() {
            this.selectedOrder = null
            this.selectedProject = null
            this.packingListForm = false
        },
        filterOrder(order) {
            return order.code
                .toString()
                .toLowerCase()
                .includes(this.appliedFilters.search)
        },
        filterByUser(order) {
            if (!order.createdByName) {
                return false
            }
            return order.createdByName
                .toLowerCase()
                .includes(this.appliedFilters.user)
        },
        filterByShippedBy(order) {
            return (order.shippedByName || '')
                .toLowerCase()
                .includes(this.appliedFilters.shippedBy)
        },
        filterStatus(order) {
            const status =
                order.status === 'referred' ? 'inDelivery' : order.status
            return status.toLowerCase().includes(this.appliedFilters.status)
        },
        filterReserved(order) {
            return (
                order.status.toLowerCase() != 'reserved' &&
                order.status.toLowerCase() != 'reservedforproject'
            )
        },
        filterByNotes(order) {
            if (order.notes) {
                return order.notes
                    .toLowerCase()
                    .includes(this.appliedFilters.notes)
            }
            return false
        },
        filterByStatus(order) {
            return order.status.toLowerCase() != 'completed'
        },
        filterWorkOrder(order) {
            return (order.selectedWorkOrdersAndBomsString || '')
                .toLowerCase()
                .includes(this.appliedFilters.workOrderAndBom)
        },
        filterProject(order) {
            return (order.projectLabel || '')
                .toLowerCase()
                .includes(this.appliedFilters.project)
        },
        filterByCreatedOn(order) {
            return (order.createdOnLabel || '')
                .toLowerCase()
                .includes(this.appliedFilters.createdOn)
        },
        filterByRequestedShipmentDate(order) {
            return (
                order.requestedShipmentDate &&
                order.requestedShipmentDate
                    .toLowerCase()
                    .includes(this.appliedFilters.requestedShipmentDate)
            )
        },
        sort() {
            this.packingLists.sort(
                (a, b) =>
                    (b.createdOn.seconds || b.createdOn._seconds) -
                    (a.createdOn.seconds || a.createdOn._seconds)
            )
        },
        findUserName(id) {
            const user = this.usersById[id]
            return user ? user.name : ''
        },
        findProject(id) {
            return (
                this.projectsById[id] || {
                    reference: '',
                    name: '',
                }
            )
        },
        async deletePackingList() {
            try {
                this.loading = true
                const packingList = await API.deletePackingList({
                    id: this.selectedOrder.id,
                    projectId: this.selectedOrder.projectId,
                })
                this.selectedOrder = null
                this.closeDeletePackingList()
                this.removePackingList(packingList)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        removePackingList(packingList) {
            this.packingLists = this.packingLists.filter(
                pl => pl.id != packingList.id
            )
        },
    },
}
</script>

<style>
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
.v-data-table__wrapper {
    max-height: 72vh;
    overflow-y: auto;
}
.v-data-table__row {
    height: 64px;
}
.v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
thead {
    position: sticky;
    z-index: 1;
}
</style>
